//  —————————————new ————————————————————————code of ap
//  Dependencies
//  ----------------------------------------------------------------------------
import { Snackbar, Alert } from '@mui/material';
//  -- Components ---------------------
import { Col, Row } from "antd";
import CoversCard from "./coverCard";
import Loading from "components/Loading";
import { filter, map, find, get } from "lodash";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlertView } from "store/alert/selectors";
import { useBookUnits } from "store/booksUnits/selectors";
import { handleListBookUnits } from "store/booksUnits/thunks";
import { useFavouriteVideo } from "store/FavouriteVideo/selectors";
import {
  handleCreateFavouriteVideo,
  handleListFavouriteVideo,
  handleListMostUsedEbookById,
} from "store/FavouriteVideo/thunks";
import { useCurrentOrgPermission } from "store/organizations/selectors";
import styled from "styled-components";
import COLOR from "utils/constants/color";
// import { useFirebase } from "./FirebaseContext";
import { BackButtonEbook } from "components/UI/buttons/Backbutton";
import AssessmentAp from "./assesmentAp";
import UnitModal from "./unitModal";
import { redirectToHome } from 'utils/config/navigation';
//  -- Constants ----------------------

//  -- Features -----------------------

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-height: 90vh;
  justify-content: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  width: calc(100% + 48px);
  margin-left: -24px;
  padding: 0px 24px;
  justify-content: center;
  padding-top: 20px;
`;

const CoverSecion = styled.div`
  width: 100%;
  //   height: 100%;
  display: flex;
  flex-wrap: wrap; /* Ensures that items wrap to the next line */
  justify-content: flex-start; /* Align items to the left side */
  overflow: hidden; /* Prevent any scroll on the right */
  margin-right: -10px; /* Optional: Adjust to make sure there is no space at the right */
  padding: 0 10px; /* Optional: Add some padding to the container */
`;

const CategoryMenu = styled.div`
  background-color: #0b1c2b;
  border-radius: 30px;
  color: #fff;
  width: 300px;
  height: 42px;
  // margin-top: 20px;
  display: flex;
  align-items: center;
  // justify-content: center;
  // text-align: center;
  color: #fff;
  // font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #fff;
  color: #fff;
  padding-left: 15px;
  // padding-right: 15px;
  justify-content: space-between;
  // margin: 20px 10px;
  // margin: 20px 20px 20px 10px;

  @media screen and (max-width: 1200px) {
    font-size: 14px;
  }
  @media screen and (max-width: 576px) {
    // margin: 15px 8px;
  }
`;

const SearchInput = styled.input`
  // width: 100px;
  // width: 80px;
  height: 100%;
  color: #fff;
  border: none;
  background: transparent;
  outline: none;
  // text-align: center;
  // font-weight: 800;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${COLOR.white};
  }
  ::focus {
    outline: none;
  }
  @media only screen and (max-width: 360px) {
    width: 92px;
  }
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------

const sortUnits = function (a, b) {
  if (Number(a.id) < Number(b.id)) {
    return 1;
  }
  if (Number(a.id) > Number(b.id)) {
    return -1;
  }
  // a must be equal to b
  return 0;
};

const resourceData = [
  {
    id: "1",
    key: "2",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5c39e77a-ab1b-4de8-cad8-68bc7158ca00/public",
    displayName: "EL CORREO ELECTRÓNICO",
    chapter_ids: "69",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/da9b67a9-60b3-49e6-8216-62a08fc89000/public",
  },
  {
    id: "2",
    key: "2",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/de727973-792e-4302-8321-b6a954773400/public",
    displayName: "LA COMPARACIÓN CULTURAL",
    chapter_ids: "70",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/1256880f-6929-498a-ca21-799c9e02ad00/public",
  },
  {
    id: "3",
    key: "3",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f1d717c2-4c1c-4cfe-eeac-daec948d9300/public",
    displayName: "LA CONVERSACIÓN SIMULADA",
    chapter_ids: "72",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/34a05797-5a2c-49f6-a896-ee3fc3764800/public",
  },
  {
    id: "4",
    key: "4",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f022ce09-9cb1-4da8-b7ca-4b0c6411ba00/public",
    displayName: "LOS ARTÍCULOS INFORMATIVOS",
    chapter_ids: "73",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/b72dcec2-d895-4438-7fb8-2a659e059600/public",
  },
  {
    id: "5",
    key: "5",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/bf48d8ae-a90e-4726-105c-49dbc7d69400/public",
    displayName: "LOS AUDIOS COMPRENSIVOS",
    chapter_ids: "75",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/3608fe60-ad8c-45d1-0d47-f0da9694af00/public",
  },
  {
    id: "6",
    key: "6",
    src: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/1dadeef7-ef74-48a3-e9d8-ef2ecb824800/public",
    displayName: "EL ENSAYO ARGUMENTATIVO",
    chapter_ids: "78",
    cover_src:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/b60d709d-d607-41cb-8639-2fecb0af9700/public",
  },
];

const ListAllAPExtraResource = ({
  currentUser,
  booksAllList,
  id,
  from,
  handleSubmit,
  items,
  config,
  pageId
}) => {
  const bookUnitList = useBookUnits();
  const location = useLocation();
  							  const navigate = useNavigate();
  const deviceType = true;
  const search = { id };
  const [CHAPTER_ID, setCHAPER_ID] = useState(id);
  const UNIT_DATA = find(bookUnitList, ["bookId", CHAPTER_ID]);
  const UNIT_PAGES = get(
    find(bookUnitList, ["bookId", CHAPTER_ID]),
    "pages",
    []
  );
  const dispatch = useDispatch();
  const [, invokeAlert, revokeALert] = useAlertView();
  const orgPermissions = useCurrentOrgPermission();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [pageRoutes, setPageRoutes] = useState(1);
  const [units, setUnits] = useState(UNIT_PAGES);
  const [loading, setLoading] = useState(false);
  const [mostUsedData, setMostUsedData] = useState([]);
  const listingRef = useRef(null);
  const [selectedCardId, setSelectedCardId] = useState("69");
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [searchQuery, setSearchQuery] = useState("");
  const allFavorites = useFavouriteVideo();
  const [fetchFavoritesList, setFetchFavorites] = useState(allFavorites);
  const [isFetchDataComplete, setIsFetchDataComplete] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const selection = from === "extraResource";
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    type: "error",
  });

  useEffect(() => {
    if (search.id) {
      setCHAPER_ID(search.id);
    }
  }, [search.id]);

  if (!CHAPTER_ID) {
    navigate(redirectToHome(currentUser) || '-1')
  }

  useEffect(() => {
    fetchFavorites();
  }, [CHAPTER_ID]);

  const showCopyRight = () => {
    setAlert({
      open: true,
      message: "Content is protected!",
      type: "error",
    });
  };
  useEffect(() => {
    setUnits(sortUnitsByNew(UNIT_PAGES));
  }, [bookUnitList, UNIT_PAGES]);

  useEffect(() => {
    if (orgPermissions && typeof orgPermissions["comunidad"] === "boolean") {
      if (!orgPermissions["comunidad"]) {
        invokeAlert();
        setTimeout(() => {
          //   history.goBack();
          revokeALert();
        }, 5000);
      }
    }
  }, [orgPermissions]);

  const fetchFavorites = async () => {
    const data = {
      user_id: currentUser.id,
      type: `AP-${CHAPTER_ID}`,
    };

    try {
      const result = await dispatch(handleListFavouriteVideo(data));
      setIsFetchDataComplete(true);
      setFetchFavorites(result);
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  };

  const fetchData = async () => {
    const forUserLoaded = localStorage.getItem("forUser");
    if (forUserLoaded == currentUser?.id || forUserLoaded == "nouser") {
      setLoading(false);
    } else {
      if (Array.isArray(bookUnitList) && bookUnitList.length > 0) {
        setLoading(false);
      } else {
        setLoading(true);
      }
    }
    await dispatch(handleListBookUnits());
    setLoading(false);
    localStorage.setItem("forUser", currentUser?.id ?? "nouser");
  };
  const fetchMostUsedVideo = async () => {
    try {
      const arr = [];
      const data = await dispatch(handleListMostUsedEbookById(CHAPTER_ID));
      if (data) {
        arr.push(data);
        setMostUsedData(arr);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    Promise.all([fetchMostUsedVideo(), fetchData()]);
  }, []);
  const showAdoption = () => {
    setAlert({
      open: true,
      message: "Comming soon...",
      type: "success",
    });
  };
  const handleClose = () => {
    setAlert({
      open: false,
      message: "",
      type: "error",
    });
  };

  const sortUnitsByNew = (res) => {
    const newUnits = filter(res, ["new", true]).sort(sortUnits);
    const oldUnits = filter(res, (k) => !k.new).sort(sortUnits);
    return [...newUnits, ...oldUnits];
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.classList.add("blue-bg-ebook");
    document.body.classList.add("overflow-x-hidden");

    return () => {
      document.body.classList.remove("overflow-x-hidden");
      document.body.classList.remove("blue-bg-ebook");
    };
  }, []);

  useEffect(() => {
    if (isFetchDataComplete) {
      const createFavourite = async () => {
        await dispatch(handleCreateFavouriteVideo(fetchFavoritesList));
      };
      createFavourite();
    }
  }, [fetchFavoritesList]);

  useEffect(() => {
    const fitlerData = find(resourceData, ["chapter_ids", search.id]);
    if (
      config?.selectedCategoryAP &&
      Object.keys(config?.selectedCategoryAP)?.length > 0
    ) {
      setPageRoutes(1);
      setSelectedCardId(config?.selectedCategoryAP?.chapter_ids);
      setCHAPER_ID(config?.selectedCategoryAP?.chapter_ids);
      setSelectedCategory(config?.selectedCategoryAP);
    } else {
      setPageRoutes(1);
      setSelectedCardId(fitlerData?.chapter_ids);
      setCHAPER_ID(fitlerData?.chapter_ids);
      setSelectedCategory(fitlerData);
    }

    setSelectedItem(items);
  }, [items, resourceData, config]);

  const handleSubmitForData = (data) => {
    handleSubmit(data, selectedCategory);
  };

  return (
    <>
      <Wrapper
        onContextMenu={(e) => {
          e.preventDefault();
          showCopyRight();
        }}
      >
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alert.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity={alert.type}>
            <strong>ALERT:</strong> {alert.message}
          </Alert>
        </Snackbar>
        {loading ? (
          <CenterContainer>
            <Loading />
          </CenterContainer>
        ) : (
          <>
            {selection ? null : (
              <BackButtonEbook
                onClick={() => navigate("/editBooks")}
                style={{
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  minWidth: 100,
                }}
              />
            )}

            <div className="flex flex-col md-column-reverse md-margin-0">
              <Row className="md-w-unset lg-grid lg-grid-four-column md-d-grid md-two-row-template one-way-ap-container pi-0 grid-4-row-template gap-55px lg-gap-31px pi-0">
                {map(
                  resourceData.filter((item) => {
                    return true;
                  }),
                  (portada) => (
                    <div
                      key={portada.key}
                      className={`${
                        selectedCardId === portada.chapter_ids &&
                        searchQuery?.length === 0
                          ? "resourceSelect"
                          : ""
                      } md-flex-1 grid-item `}
                    >
                      <CoversCard
                        data={portada}
                        handleClick={() => {
                          const chapterId = portada?.chapter_ids;

                          if (chapterId === "9") {
                            setSelectedCardId(chapterId);
                            setPageRoutes(3);
                          } else if (chapterId === "8") {
                            setSelectedCardId(chapterId);
                            setPageRoutes(2);
                          } else {
                            setPageRoutes(1);
                            setSelectedCardId(chapterId);
                            setCHAPER_ID(chapterId);
                            setSelectedItem([]);
                            setSelectedCategory(portada);
                            // navigate(`/edit-all-ap?id=${chapterId}`);

                            setTimeout(() => {
                              if (listingRef.current) {
                                listingRef.current.scrollIntoView({
                                  behavior: "smooth",
                                });
                              }
                            }, 300);
                          }
                        }}
                        isPodcastImage={true}
                      />
                    </div>
                  )
                )}
              </Row>
            </div>
            <Row>
              <Col xs={{ span: 24 }} lg={{ span: 14 }}></Col>
            </Row>
            {pageRoutes == 1 && (
              <CoverSecion
                ref={listingRef}
                overflowItem={units.length > 12}
                style={{ paddingTop: deviceType ? 10 : 0 }}
              >
                <UnitModal
                  booksAllList={booksAllList}
                  UNIT_DATA={UNIT_DATA}
                  selection={selection}
                  handleSubmit={handleSubmitForData}
                  items={items}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  pageId={pageId}
                />
              </CoverSecion>
            )}
            {pageRoutes == 2 && (
              <div style={{ marginTop: 24 }}>
                <AssessmentAp selection={selection} />
              </div>
            )}
          </>
        )}
      </Wrapper>
    </>
  );
};


const mapStateToProps = (state) => ({
  currentClass: state.currentClass,
  currentUser: state.currentUser,
  tipsBook: state.tipsBook,
  currentClass: state.currentClass,
  classUsers: state.classUsers,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  submissions: state.submissions,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(ListAllAPExtraResource);
